import React from 'react';
import Footer from '../../components/layout/Footer';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import '../../assets/style/itemStyle/common.scss';
import { supportEmail } from '../../untils/constant/email';

const PrivacyPolicy = () => {
  return (
    <>
      <HeaderMeta type="privacyPolicy" />
      <div className="privacy-policy-content">
        <p style={{ 'text-align': 'center' }}>
          <h1 style={{ 'text-decoration': 'underline' }}>PRIVACY POLICY</h1>
        </p>

        <p>
          This website is operated by AIRACER. The privacy of our users is extremely important to us
          and therefore we encourage all users to read this policy very carefully because it
          contains important information. This privacy policy will inform you as to how we look
          after your personal data when you visit our website (regardless of where you visit it
          from) or by making an enquiry of us.  We will also tell you about your privacy rights and
          how the law protects you.
        </p>
        <h2 id="purpose-of-this-privacy-policy">Purpose of this privacy policy</h2>
        <p>
          This privacy policy aims to give you information on how AIRACER collects and processes
          your personal data which we collect through your contact with us, including any data you
          may provide during the course of our relationship with you as a client of potential
          client. The data maybe collected by your use of our website, through direct contact with
          our employees or authorised agents through telephone, email or social media or through any
          other legitimate means not specifically identified here.
        </p>
        <p>
          This website is not intended for children and we do not knowingly collect data relating to
          children.
        </p>
        <p>
          It is important that you read this privacy policy together with any other privacy policy
          or fair processing policy we may provide on specific occasions when we are collecting or
          processing personal data about you so that you are fully aware of how and why we are using
          your data. This privacy policy supplements other notices and privacy policies and is not
          intended to override them.
        </p>
        <h2 id="controller">Controller</h2>
        <p>
          AIRACER is the controller and responsible for your personal data (collectively referred to
          as “AIRACER”, “we”, “us” or “our” in this privacy policy).
        </p>
        <h2 id="contact-details">Contact details</h2>
        <p>
          For any questions you may have about this Privacy Policy or any issue regarding our use of
          your personal data, please contact AIRACER by email at{' '}
          <a href={`mailto:${supportEmail}`} title={`mailto:${supportEmail}`}>
            {supportEmail}
          </a>
        </p>
        <p>
          You have the right to file a complaint at any time with the Federal Trade Commission (FTC)
          or another relevant authority in the United States regarding data protection issues (
          <a href="https://www.ftc.gov/" title="https://www.ftc.gov">
            www.ftc.gov
          </a>
          ). However, we would greatly appreciate the opportunity to address your concerns first.
          Please contact us directly to discuss any issues before reaching out to the regulatory
          body.
        </p>
        <h2 id="your-duty-to-inform-us-of-changes">Your duty to inform us of changes</h2>
        <p>
          We keep our privacy policy under regular review. This privacy policy was published on
          September 30th, 2022 and historic versions can be obtained by contacting us.
        </p>
        <p>
          It is important that the personal data we hold about you is accurate and current. Please
          keep us informed if your personal data changes during your relationship with us.
        </p>
        <h2 id="third-party-links">Third-party links</h2>
        <p>
          This website may include links to third-party websites, plug-ins and applications.
          Clicking on those links or enabling those connections may allow third parties to collect
          or share data about you. We do not control these third-party websites and are not
          responsible for their privacy statements. When you leave our website, we encourage you to
          read the privacy policy of every website you visit.
        </p>
        <h2 id="the-data-we-collect-about-you">The data we collect about you</h2>
        <p>
          Personal data, or personal information, means any information about an individual from
          which that person can be identified. It does not include data where the identity has been
          removed (anonymous data).
        </p>
        <p>
          We may collect, use, store and transfer different kinds of personal data about you which
          we have grouped together as follows:
        </p>
        <p>
          <strong>Identity Data</strong> includes first name, maiden name, last name, title, job
          title, username or similar identifier, potentially your business /company name, marital
          status, gender (where required), passport or ID number and photo.
        </p>
        <p>
          <strong>Contact Data</strong> includes billing address, postal address, email address and
          telephone numbers.
        </p>
        <p>
          <strong>Financial Data</strong> includes bank account details and payment card details.
        </p>
        <p>
          <strong>Travel Data</strong> includes information about your booking and travel itinerary
          and arrangements, revisions to booked arrangements, dietary requirements, special
          assistance that you may require, or other passengers travelling on your booking or
          connection with your travel itinerary, details of any travel, visa and work permit
          information where this is required by the authorities in any destination.
        </p>
        <p>
          <strong>Medical Data</strong> includes details about any medical conditions or medical
          results that may be relevant to or affect your proposed journey, and / or your ability to
          travel between countries.
        </p>
        <p>
          <strong>Technical Data</strong> includes [internet protocol (IP) address, your login data,
          browser type and version, time zone setting and location, browser plug-in types and
          versions, operating system and platform, and other technology on the devices you use to
          access this website.
        </p>
        <p>
          <strong>Usage Data</strong> includes information about how you use our website, products
          and services.
        </p>
        <p>
          <strong>Profile Data</strong> includes your quote requests and flight bookings, your
          interests, preferences, feedback and survey responses. 
        </p>
        <p>
          <strong>Marketing and Communications Data</strong> includes your preferences in receiving
          marketing from us and our third parties and your communication preferences.
        </p>
        <p>
          We also collect, use and share <strong>Aggregated Data</strong> such as statistical or
          demographic data for any purpose. Aggregated Data could be derived from your personal data
          but is not considered personal data in law as this data will <strong>not</strong> directly
          or indirectly reveal your identity. For example, we may aggregate your Usage Data to
          calculate the percentage of users accessing a specific website feature. However, if we
          combine or connect Aggregated Data with your personal data so that it can directly or
          indirectly identify you, we treat the combined data as personal data which will be used in
          accordance with this privacy policy.
        </p>
        <p>
          We may collect <strong>Special Categories of Personal Data</strong> about you (this
          includes details about your race or ethnicity, religious or philosophical beliefs, sex
          life, sexual orientation, political opinions, trade union membership, information about
          your health, and genetic and biometric data, any information about criminal convictions
          and offenses) in order to perform the required services.
        </p>
        <h2 id="if-you-fail-to-provide-personal-data">If you fail to provide personal data</h2>
        <p>
          Where we need to collect personal data by law, or under the terms of a contract we have
          with you, and you fail to provide that data when requested, we may not be able to perform
          the contract we have or are trying to enter into with you (for example, to provide you
          with goods or services). In this case, we may have to cancel a product or service you have
          with us but we will notify you if this is the case at the time.
        </p>
        <h2 id="how-is-your-personal-data-collected">How is your personal data collected?</h2>
        <p>We use different methods to collect data from and about you including through:</p>
        <p>
          <strong>Direct interactions.</strong> You may give us your Identity, Contact, Financial,
          Travel or Medical Data by filling in forms or by corresponding with us by post, phone,
          email or otherwise. This includes personal data you provide when you:
        </p>
        <p>ask for a quote for services;</p>
        <p>apply for our products or services;</p>
        <p>place an order for our services directly or through a third party;</p>
        <p>create an account on our website;</p>
        <p>subscribe to our service or publications;</p>
        <p>request marketing to be sent to you; or</p>
        <p>give us feedback or contact us.</p>
        <p>
          <strong>Automated technologies or interactions.</strong> As you interact with our website,
          we will automatically collect Technical Data about your equipment, browsing actions and
          patterns. We collect this personal data by using cookies and other similar technologies.
        </p>
        <p>
          <strong>Biometric Data.</strong> You should be aware that in some airports facial
          recognition and biometric technology is used to facilitate passenger boarding.
        </p>
        <p>
          <strong>Third parties or publicly available sources.</strong> We will receive personal
          data about you from various third parties and public sources as set out below:
        </p>
        <ul>
          <li>
            <p>Technical Data from analytics providers such as Google based outside the EU;</p>
          </li>
          <li>
            <p>
              Contact, Financial and Transaction Data from providers of technical, payment and
              delivery services such as Thomas Reuters based inside <strong>and</strong> outside the
              EU; and
            </p>
          </li>
          <li>
            <p>
              Identity and Contact Data from publicly available sources such as Companies House and
              the Electoral Register based inside the US.
            </p>
          </li>
        </ul>
        <h2 id="how-we-use-your-personal-data">How we use your personal data</h2>
        <p>
          We will only use your personal data when the law allows us to. Most commonly, we will use
          your personal data in the following circumstances:
        </p>
        <ul>
          <li>
            <p>
              Where we need to perform the contract we are about to enter into or have entered into
              with you.
            </p>
          </li>
          <li>
            <p>
              Where it is necessary for our legitimate interests (or those of a third party) and
              your interests and fundamental rights do not override those interests.
            </p>
          </li>
          <li>
            <p>Where we need to comply with a legal or regulatory obligation.</p>
          </li>
        </ul>
        <p>
          Generally, we do not rely on consent as a legal basis for processing your personal data
          although we will get your consent before sending third party direct marketing
          communications to you via email or text message. You have the right to withdraw consent to
          marketing at any time by contacting us.
        </p>
        <h2 id="purposes-for-which-we-will-use-your-personal-data">
          Purposes for which we will use your personal data
        </h2>
        <p>
          We have set out below, in a table format, a description of all the ways we plan to use
          your personal data, and which of the legal bases we rely on to do so. We have also
          identified what our legitimate interests are where appropriate.
        </p>
        <p>
          Note that we may process your personal data for more than one lawful ground depending on
          the specific purpose for which we are using your data. Please contact us if you need
          details about the specific legal ground we are relying on to process your personal data
          where more than one ground has been set out in the table below.
        </p>
        <table>
          <thead>
            <tr>
              <th>
                <strong>Purpose/Activity</strong>
              </th>
              <th>
                <strong>Type of data</strong>
              </th>
              <th>
                <strong>Lawful basis for processing including basis of legitimate interest</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>To register you as a new customer</td>
              <td>
                (a) Identity <br />
                (b) Contact
              </td>
              <td>
                Performance of a contract with you for the request for our services.
                <br />
                <br />
                Necessary for our legitimate interests (to ensure we retain accurate records
                relating to you and to performance of engagements for our services (including
                enquiries made for our services)
              </td>
            </tr>
            <tr>
              <td>
                To manage our relationship with you which will include: <br />
                (a) Notifying you about changes to our terms or privacy policy <br />
                (b) Asking you to leave a review or take a survey <br />
                (c) validating your provided information
              </td>
              <td>
                (a) Identity <br />
                (b) Contact <br />
                (c) Profile <br />
                (d) Marketing and Communications
              </td>
              <td>
                (a) Performance of a contract with you <br />
                (b) Necessary to comply with a legal obligation <br />
                (c) Necessary for our legitimate interests (to keep our records updated and to study
                how customers use our products/services)
              </td>
            </tr>
            <tr>
              <td>
                To manage our relationship with you which will include: (a) Notifying you about
                changes to our terms or privacy policy (b) Asking you to leave a review or take a
                survey
              </td>
              <td>
                (a) Identity <br />
                (b) Contact <br />
                (c) Profile <br />
                (d) Marketing and Communications
              </td>
              <td>
                (a) Performance of a contract with you (b) Necessary to comply with a legal
                obligation (c) Necessary for our legitimate interests (to keep our records updated
                and to study how customers use our products/services)
              </td>
            </tr>
            <tr>
              <td>
                To administer and protect our business and this website (including troubleshooting,
                data analysis, testing, system maintenance, support, reporting and hosting of data)
              </td>
              <td>
                (a) Identity <br />
                (b) Contact <br />
                (c) Technical
              </td>
              <td>
                (a) Necessary for our legitimate interests (for running our business, provision of
                administration and IT services, network security, to prevent fraud and in the
                context of a business reorganisation or group restructuring exercise) <br />
                (b) Necessary to comply with a legal obligation
              </td>
            </tr>
            <tr>
              <td>
                To deliver relevant website content and advertisements to you and measure or
                understand the effectiveness of the advertising we serve to you
              </td>
              <td>
                ((a) Identity <br />
                (b) Contact <br />
                (c) Profile <br />
                (d) Usage <br />
                (e) Marketing and Communications <br />
                (f) Technical
              </td>
              <td>
                Necessary for our legitimate interests (to study how customers use our
                products/services, to develop them, to grow our business and to inform our marketing
                strategy)
              </td>
            </tr>
            <tr>
              <td>
                To use data analytics to improve our website, products/services, marketing, customer
                relationships and experiences
              </td>
              <td>
                (a) Technical <br />
                (b) Usage
              </td>
              <td>
                Necessary for our legitimate interests (to define types of customers for our
                products and services, to keep our website updated and relevant, to develop our
                business and to inform our marketing strategy)
              </td>
            </tr>
            <tr>
              <td>
                To make suggestions and recommendations to you about goods or services that may be
                of interest to you
              </td>
              <td>
                (a) Identity <br />
                (b) Contact <br />
                (c) Technical <br />
                (d) Usage <br />
                (e) Profile <br />
                (f) Marketing and Communications
              </td>
              <td>
                Necessary for our legitimate interests (to develop our products/services and grow
                our business)
              </td>
            </tr>
          </tbody>
        </table>
        <h2 id="marketing">Marketing</h2>
        <p>
          We strive to provide you with choices regarding certain personal data uses, particularly
          around marketing and advertising. We have established the following personal data control
          mechanisms:
        </p>
        <p>
          <strong>Promotional offers from us</strong>
        </p>
        <p>
          We may use your Identity, Contact, Technical, Usage and Profile Data to form a view on
          what we think you may want or need, or what may be of interest to you. This is how we
          decide which products, services and offers may be relevant for you (we call this
          marketing).
        </p>
        <p>
          You will receive marketing communications from us if you have requested information from
          us or purchased broker services from us and you have not opted out of receiving that
          marketing.
        </p>
        <p>
          <strong>Opting out</strong>
        </p>
        <p>
          You can ask us or third parties to stop sending you marketing messages at any by
          contacting us at any time.
        </p>
        <p>
          Where you opt out of receiving these marketing messages, this will not apply to personal
          data provided to us as a result of our provision of broker services to you.
        </p>
        <h2 id="change-of-purpose">Change of purpose</h2>
        <p>
          We will only use your personal data for the purposes for which we collected it, unless we
          reasonably consider that we need to use it for another reason and that reason is
          compatible with the original purpose. If you wish to get an explanation as to how the
          processing for the new purpose is compatible with the original purpose, please contact us.
        </p>
        <p>
          If we need to use your personal data for an unrelated purpose, we will notify you and we
          will explain the legal basis which allows us to do so.
        </p>
        <p>
          Please note that we may process your personal data without your knowledge or consent, in
          compliance with the above rules, where this is required or permitted by law.
        </p>
        <h2 id="disclosures-of-your-personal-data">Disclosures of your personal data</h2>
        <p>
          We may share your personal data with the parties set out below for the purposes set out in
          the table <em>Purposes for which we will use your personal data</em> above.
        </p>
        <p>External Third Parties in order to perform the required services.</p>
        <p>
          Third parties to whom we may choose to sell, transfer or merge parts of our business or
          our assets. Alternatively, we may seek to acquire other businesses or merge with them. If
          a change happens to our business, then the new owners may use your personal data in the
          same way as set out in this privacy policy.
        </p>
        <p>
          We require all third parties to respect the security of your personal data and to treat it
          in accordance with the law. We do not allow our third-party service providers to use your
          personal data for their own purposes and only permit them to process your personal data
          for specified purposes and in accordance with our instructions.
        </p>
        <h2 id="international-transfers">International transfers</h2>
        <p>
          We may need to share your personal data with third party Operators or other professional
          advisors with whom it is necessary to share your personal data in order to provide you
          with the services we have contracted with you for. This may involve transferring your data
          outside the European Economic Area (EEA).
        </p>
        <p>
          Whenever we transfer your personal data out of the EEA, we ensure a similar degree of
          protection is afforded to it by ensuring at least one of the following safeguards is
          implemented:
        </p>
        <ul>
          <li>
            <p>
              We will only transfer your personal data to countries that have been deemed to provide
              an adequate level of protection for personal data. For further details, see European
              Commission: Adequacy of the protection of personal data in non-EU countries.
            </p>
          </li>
          <li>
            <p>
              Where we use certain service providers, we may use specific contracts approved by the
              European Commission which give personal data the same protection it has in Europe. For
              further details, see European Commission: Model contracts for the transfer of personal
              data to third countries. 
            </p>
          </li>
          <li>
            <p>
              Where we use providers based in the US, we may transfer data to them if they are part
              of the Privacy Shield which requires them to provide similar protection to personal
              data shared between the Europe and the US. For further details, see European
              Commission: EU-US Privacy Shield.
            </p>
          </li>
        </ul>
        <p>
          Please contact us if you want further information on the specific mechanism used by us
          when transferring your personal data out of the US
        </p>
        <h2 id="data-security">Data security</h2>
        <p>
          We have put in place appropriate security measures to prevent your personal data from
          being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In
          addition, we limit access to your personal data to those employees, agents, contractors
          and other third parties who have a business need to know. They will only process your
          personal data on our instructions and they are subject to a duty of confidentiality.
        </p>
        <p>
          We have put in place procedures to deal with any suspected personal data breach and will
          notify you and any applicable regulator of a breach where we are legally required to do
          so.
        </p>
        <h2 id="how-long-will-you-use-my-personal-data-for">
          How long will you use my personal data for?
        </h2>
        <p>
          We will only retain your personal data for as long as reasonably necessary to fulfil the
          purposes we collected it for, including for the purposes of satisfying any legal,
          regulatory, tax, accounting or reporting requirements. We may retain your personal data
          for a longer period in the event of a complaint or if we reasonably believe there is a
          prospect of litigation in respect to our relationship with you.
        </p>
        <p>
          To determine the appropriate retention period for personal data, we consider the amount,
          nature and sensitivity of the personal data, the potential risk of harm from unauthorised
          use or disclosure of your personal data, the purposes for which we process your personal
          data and whether we can achieve those purposes through other means, and the applicable
          legal, regulatory, tax, accounting or other requirements.
        </p>
        <p>
          In some circumstances you can ask us to delete your data: see <em>your legal rights</em>{' '}
          below for further information.
        </p>
        <p>
          In some circumstances we will anonymize your personal data (so that it can no longer be
          associated with you) for research or statistical purposes, in which case we may use this
          information indefinitely without further notice to you.
        </p>
        <h2 id="your-legal-rights">Your legal rights</h2>
        <p>
          Under certain circumstances, you have rights under data protection laws in relation to
          your personal data:
        </p>
        <p>
          <em>Request access to your personal data</em>.
        </p>
        <p>
          <em>Request correction of your personal data</em>.
        </p>
        <p>
          <em>Request erasure of your personal data</em>.
        </p>
        <p>
          <em>Object to processing of your personal data</em>.
        </p>
        <p>
          <em>Request restriction of processing your personal data</em>.
        </p>
        <p>
          <em>Request transfer of your personal data</em>.
        </p>
        <p>
          <em>Right to withdraw consent</em>.
        </p>
        <p>If you wish to exercise any of the rights set out above, please contact us.</p>
        <h2 id="no-fee-usually-required">No fee usually required</h2>
        <p>
          You will not have to pay a fee to access your personal data (or to exercise any of the
          other rights). However, we may charge a reasonable fee if your request is clearly
          unfounded, repetitive or excessive. Alternatively, we could refuse to comply with your
          request in these circumstances.
        </p>
        <h2 id="what-we-may-need-from-you">What we may need from you</h2>
        <p>
          We may need to request specific information from you to help us confirm your identity and
          ensure your right to access your personal data (or to exercise any of your other rights).
          This is a security measure to ensure that personal data is not disclosed to any person who
          has no right to receive it. We may also contact you to ask you for further information in
          relation to your request to speed up our response.
        </p>
        <h2 id="time-limit-to-respond">Time limit to respond</h2>
        <p>
          We try to respond to all legitimate requests within one month. Occasionally it could take
          us longer than a month if your request is particularly complex or you have made a number
          of requests. In this case, we will notify you and keep you updated.
        </p>
        <h2 id="glossary">Glossary</h2>
        <h3 id="lawful-basis">LAWFUL BASIS</h3>
        <p>
          <strong>Legitimate Interest</strong> means the interest of our business in conducting and
          managing our business to enable us to give you the best service/product and the best and
          most secure experience. We make sure we consider and balance any potential impact on you
          (both positive and negative) and your rights before we process your personal data for our
          legitimate interests. We do not use your personal data for activities where our interests
          are overridden by the impact on you (unless we have your consent or are otherwise required
          or permitted to by law). You can obtain further information about how we assess our
          legitimate interests against any potential impact on you in respect of specific activities
          by contacting us.
        </p>
        <p>
          <strong>Performance of Contract</strong> means processing your data where it is necessary
          for the performance of a contract to which you are a party or to take steps at your
          request before entering into such a contract.
        </p>
        <p>
          <strong>Comply with a legal obligation</strong> means processing your personal data where
          it is necessary for compliance with a legal obligation that we are subject to.
        </p>
        <h3 id="third-parties">THIRD PARTIES</h3>
        <p>
          <strong>External Third Parties</strong>
        </p>
        <p>
          Service providers acting as processors based within the EEA who provide IT and system
          administration services.
        </p>
        <p>
          Third parties that provide travel assistance such as but not limited to companies that
          provide ground transportation services, ground handling, catering, customs and immigration
          authorities.
        </p>
        <p>
          Professional advisers and aviation professions acting as processors or joint controllers
          including lawyers, bankers, auditors, insurers, aviation agents or brokers based both in
          the EEA and outside the EEA who provide consultancy, banking, legal, insurance and
          accounting services.
        </p>
        <p>
          The air operators or carriers acting as processors based both in the EEA and outside the
          EEA.
        </p>
        <p>
          HM Revenue &amp; Customs, regulators and other authorities based in the United Kingdom who
          require reporting of processing activities in certain circumstances. Depending on the
          nature of the broker services we are providing to you, the regulators or other authorities
          may be based both inside or outside the EEA. Fraud prevention agencies or other providers
          of services utilised for the purposes of detecting or preventing fraud, ensuring
          compliance with anti-money laundering, bribery or corruption legislation or otherwise
          assisting us in conducting necessary due diligence required of us by professional rules of
          conduct or other relevant laws.
        </p>
        <h3 id="your-legal-rights-1">YOUR LEGAL RIGHTS</h3>
        <p>You have the right to:</p>
        <p>
          <strong>Request access</strong> to your personal data (commonly known as a “data subject
          access request”). This enables you to receive a copy of the personal data we hold about
          you and to check that we are lawfully processing it.
        </p>
        <p>
          <strong>Request correction</strong> of the personal data that we hold about you. This
          enables you to have any incomplete or inaccurate data we hold about you corrected, though
          we may need to verify the accuracy of the new data you provide to us.
        </p>
        <p>
          <strong>Request erasure</strong> of your personal data. This enables you to ask us to
          delete or remove personal data where there is no good reason for us continuing to process
          it. You also have the right to ask us to delete or remove your personal data where you
          have successfully exercised your right to object to processing (see below), where we may
          have processed your information unlawfully or where we are required to erase your personal
          data to comply with local law. Note, however, that we may not always be able to comply
          with your request of erasure for specific legal reasons which will be notified to you, if
          applicable, at the time of your request.
        </p>
        <p>
          <strong>Object to processing</strong> of your personal data where we are relying on a
          legitimate interest (or those of a third party) and there is something about your
          particular situation which makes you want to object to processing on this ground as you
          feel it impacts on your fundamental rights and freedoms. You also have the right to object
          where we are processing your personal data for direct marketing purposes. In some cases,
          we may demonstrate that we have compelling legitimate grounds to process your information
          which override your rights and freedoms.
        </p>
        <p>
          <strong>Request restriction of processing</strong> of your personal data. This enables you
          to ask us to suspend the processing of your personal data in the following scenarios:
        </p>
        <p>If you want us to establish the data’s accuracy.</p>
        <p>Where our use of the data is unlawful but you do not want us to erase it.</p>
        <p>
          Where you need us to hold the data even if we no longer require it as you need it to
          establish, exercise or defend legal claims.
        </p>
        <p>
          You have objected to our use of your data but we need to verify whether we have overriding
          legitimate grounds to use it.
        </p>
        <p>
          <strong>Request the transfer</strong> of your personal data to you or to a third party. We
          will provide to you, or a third party you have chosen, your personal data in a structured,
          commonly used, machine-readable format. Note that this right only applies to automated
          information which you initially provided consent for us to use or where we used the
          information to perform a contract with you.
        </p>
        <p>
          <strong>Withdraw consent at any time</strong> where we are relying on consent to process
          your personal data. However, this will not affect the lawfulness of any processing carried
          out before you withdraw your consent. If you withdraw your consent, we may not be able to
          provide certain products or services to you. We will advise you if this is the case at the
          time you withdraw your consent.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
